const LOADING_STATES = {
    LOADING: 'loading',
    RESOLVED: 'resolved',
    REJECTED: 'rejected',
    EMPTY: 'empty',
    NOTIFICATION: 'notification',
    CANCELLED: 'cancelled',
};

export default LOADING_STATES;